// export type ItemSelector<T> = (items: T[]) => T;

export function randomItem(array) {
    if (array.length === 0) {
        throw new Error('Array is empty');
    }
    return array[Math.floor(array.length * Math.random())];
}
